import { createRoute } from "@tanstack/solid-router";
// FLAGS: la página entera se gatea por feature (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { MessageSquare } from "lucide-solid";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { CrmTabs } from "@/features/crm/crm-tabs";
import { TemplatesView } from "@/features/crm/templates-view";

function CrmTemplatesPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="6xl">
      <PageHeader
        title={t(msg`WhatsApp templates`)}
        description={t(msg`Reusable message templates`)}
        icon={MessageSquare}
        backTo="/crm"
      />
      <div class="mt-4">
        <CrmTabs />
        <TemplatesView />
      </div>
    </PageContainer>
  );
}

export const crmTemplatesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/crm/templates",
  component: withFeatureGate("crm.leads", CrmTemplatesPage),
});
